import url from './urls'

const state = {
  categorys: null,
  committees: null,
  chairmanBios: null,
  isLoading: false,
  workingcommittee: null,
  workingcommitteeDuration: false,
  workingcommitteeCategory: null
}

const mutations = {
  GETCATEGORY (state) {
    state.isLoading = true

    fetch(url.about.committeeCategory)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.categorys = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETCOMMITTEE (state, id) {
    state.isLoading = true

    fetch(url.about.committee + id)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.committees = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETCHAIRMANBIO (state) {
    state.isLoading = true

    fetch(url.about.chairmanBiography)
      .then(response => response.json())
      .then(data => {
        setTimeout(() => {
          state.isLoading = false
        }, 1000)

        state.chairmanBios = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETWORKINGCOMITTEEDURATION (state) {
    state.isLoading = true

    fetch(url.about.workingcommitteeDuration)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.workingcommitteeDuration = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETWORKINGCOMITTEE (state, id) {
    state.isLoading = true
    let newUrl
    if (id) {
      newUrl = url.about.workingcommittee + `?subcategory=${id}`
    } else {
      newUrl = url.about.workingcommittee
    }
    fetch(newUrl)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.workingcommittee = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETWORKINGCOMITTEECATEGORY (state) {
    state.isLoading = true

    fetch(url.about.workingcommitteeCategory)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.workingcommitteeCategory = data.data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  }
}

const actions = {
  getCategory ({ commit }) {
    commit('GETCATEGORY')
  },

  getCommittee ({ commit }, id) {
    commit('GETCOMMITTEE', id)
  },

  getChairmanBio ({ commit }) {
    commit('GETCHAIRMANBIO')
  },

  getWorkingCommitteeDuration ({ commit }) {
    commit('GETWORKINGCOMITTEEDURATION')
  },

  getWorkingCommittee ({ commit }, id) {
    commit('GETWORKINGCOMITTEE', id)
  },

  getWorkingCommitteeCategory ({ commit }) {
    commit('GETWORKINGCOMITTEECATEGORY')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
